//#Global Imports
import React, { useEffect, useState } from "react";
import clsx from "clsx";
import Countdown, { zeroPad } from "react-countdown";
import { Controller, useForm } from "react-hook-form";
//#end Global Imports

//#Local Imports
import { IRemitterProps } from "./Remmiter";
import Button from "../../components/ui/Button";
import Modal from "../../components/ui/Modal";
import TextField from "../../components/ui/TextField";
import Typograpy from "../../components/ui/Typography";
import ErrorField from "../../components/ui/ErrorField";
import {
  getErrorMessage,
  regexForEmailAddress,
  regexForMobileNumber,
} from "../../utils";
import { Mixpanel } from "../../constants/mixpanel";
import { useRecoilValue } from "recoil";
import { panDeclaration } from "../../store";
//#end Local Imports

const AddNewRemitterModal: React.FC<
  IRemitterProps.IAddNewRemitterModalProps
> = ({
  addRemmitterModal,
  isMobileVerified,
  isModalOpen,
  setIsModalOpen,
  handleMobileVerification,
  handleLinkVerification,
  date,
  dateKey,
  onSubmit,
  otpError,
  isOtpSend,
  signUpError,
  selectedRemitter,
  handleTransactionUpdate,
  handleConfirmedRemitterDelete,
  formData,
  handleAddNewRemitterModalClose,
  setIsMobileVerified,
  addRemitterOnChangeHandler,
  isSendLink,
  setIsSendLink,
  isOtpDisabled,
  otpLoading,
  panMismatchError,
  handleResendKycLink,
}) => {
    type FormInputs = {
      email: string;
      mobileNumber: string;
      otp: string;
    };

    const [otpSentCheck, setOtpSentCheck] = useState(false);
    const [skipClicked, setSkipClicked] = useState(false)


    const panDeclarationValue = useRecoilValue(panDeclaration);

    const {
      formState: { errors },
      handleSubmit,
      control,
      clearErrors,
    } = useForm<FormInputs>({ mode: "onChange" });
    const clearErrosHandler = () => {
      clearErrors(["email", "mobileNumber", "otp"]);
    };



    return (
      <>
        {/* Add New Remitter Modal */}
        <Modal
          visible={addRemmitterModal}
          closable={false}
          closeHandler={() => {
            handleAddNewRemitterModalClose();
            clearErrosHandler();
            setIsMobileVerified(false);
            setOtpSentCheck(false)
            setSkipClicked(false)
          }}
          modalClass="!p-0"
          headerClass="!my-0"
        >
          <div className="px-6 py-10 bg-[#fff]">
            <Typograpy
              tagType="div"
              className="text-base font-bold text-black mb-6"
              text="Remitter contact details"
            />
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="flex flex-col items-center gap-6"
            >
              <div className="w-full sm:w-[372px]">
                <Controller
                  control={control}
                  name="email"
                  rules={{ required: true, pattern: regexForEmailAddress }}
                  render={({ field: { name, onChange } }) => {
                    return (
                      <TextField
                        name={name}
                        type="email"
                        placeholder="Email"
                        inputClasses="border-[#EEEFF2]"
                        placeholderStyle="text-[#006EFF] font-ssp font-normal text-base"
                        value={formData?.email}
                        onChange={(v) => {
                          addRemitterOnChangeHandler(v.target.value, "email");
                          onChange(v);
                        }}
                        // eslint-disable-next-line
                        errorMessage={getErrorMessage(
                          errors as Record<string, { type: any }>,
                          "email",
                          "Email"
                        )}
                        error={errors.email}
                        required
                        fullWidth
                      />
                    );
                  }}
                />
              </div>
              <div className="w-full sm:w-[372px] relative">
                <Controller
                  control={control}
                  name="mobileNumber"
                  rules={{ required: true, pattern: regexForMobileNumber }}
                  render={({ field: { name, onChange } }) => {
                    return (
                      <TextField
                        name={name}
                        type="number"
                        placeholder="Mobile Number"
                        inputClasses="border-[#EEEFF2]"
                        placeholderStyle="text-[#006EFF] font-ssp font-normal text-base"
                        value={formData?.mobileNumber}
                        onChange={(v) => {
                          const mobileNumber = v.target.value;
                          addRemitterOnChangeHandler(
                            mobileNumber,
                            "mobileNumber"
                          );
                          onChange(v);
                          mobileNumber.length < 10 && setOtpSentCheck(false)
                        }}
                        // eslint-disable-next-line
                        errorMessage={getErrorMessage(
                          errors as Record<string, { type: any }>,
                          "mobileNumber",
                          "Mobile Number"
                        )}
                        error={errors.mobileNumber}
                        required
                        fullWidth
                      />
                    );
                  }}
                />
              </div>
              {formData?.mobileNumber !== "" && formData?.email !== "" && !errors.mobileNumber && otpSentCheck === true && (
                <Controller
                  control={control}
                  name="otp"
                  rules={{ required: true, maxLength: 6, minLength: 6 }}
                  render={({ field: { name, onChange } }) => {
                    return (
                      <TextField
                        name={name}
                        type="number"
                        placeholder="OTP"
                        inputClasses="border-[#EEEFF2]"
                        placeholderStyle="text-[#006EFF] font-ssp font-normal text-base"
                        value={formData?.otpValue}
                        onChange={(v) => {
                          addRemitterOnChangeHandler(v.target.value, "otpValue");
                          onChange(v);
                        }}
                        errorMessage={
                          otpError ||
                          getErrorMessage(
                            errors as Record<string, { type: any }>,
                            "otp",
                            "OTP"
                          )
                        }
                        error={otpError !== "" || errors.otp}
                        required
                        fullWidth
                        disabled={isOtpDisabled}
                      />
                    );
                  }}
                />
              )}
              <div className="w-full sm:w-[372px] flex items-center gap-8">
                <Button
                  bgColor={"bg-[#006EFF]"}
                  fontStyle={{
                    fontFamily: "font-ssp",
                    fontSize: "text-sm",
                    fontWeight: "font-semibold",
                    fontColor: "text-white",
                  }}
                  borderStyle={{
                    borderRadius: "rounded",
                  }}
                  className="py-4 px-6 sm:h-[48px]"
                  disabled={
                    otpLoading ||
                    !formData?.mobileNumber ||         // Disable if mobile number is not filled
                    formData?.mobileNumber.length < 10 || // Disable if mobile number is less than 10 digits
                    errors.mobileNumber ||
                    errors.email ||
                    !formData?.email                    // Disable if email is not filled
                  }
                  onClickHandler={() => {
                    if (skipClicked && !errors.mobileNumber) {
                      Mixpanel.track("Proceed_new_remitter");
                      handleLinkVerification("skip", "link");
                    }
                    else if (skipClicked !== true) {
                      setOtpSentCheck(true);
                      if (otpSentCheck) {
                        Mixpanel.track("Proceed_new_remitter");
                      } else {
                        handleMobileVerification("send", "mobile");
                      }
                    }
                  }}
                >
                  {otpLoading ? (
                    <div className="mx-10 loader ease-linear rounded-full border-2 border-t-2 border-t-gray-300 border-white h-5 w-5"></div>
                  ) : (
                    otpSentCheck || skipClicked ? "PROCEED" : "VERIFY"
                  )}
                </Button>

                <Button
                  type="button"
                  bgColor="bg-[#F3F3F4]"
                  fontStyle={{
                    fontFamily: "font-ssp",
                    fontSize: "text-sm",
                    fontWeight: "font-semibold",
                    fontColor: "text-black",
                  }}
                  borderStyle={{
                    borderRadius: "rounded",
                  }}
                  className="py-4 px-6 sm:h-[48px]"
                  disabled={
                    otpLoading ||
                    !formData?.mobileNumber ||         // Disable if mobile number is not filled
                    formData?.mobileNumber.length < 10 || // Disable if mobile number is less than 10 digits
                    errors.mobileNumber ||
                    errors.email ||
                    !formData?.email                    // Disable if email is not filled
                  }
                  onClickHandler={() => {
                    if (otpSentCheck) {
                      setIsSendLink(true);
                      handleLinkVerification("send", "link");
                      Mixpanel.track("Proceed_new_remitter");
                    } else {
                      setSkipClicked(true);
                      if (skipClicked) {
                        handleLinkVerification("skip", "link");
                        Mixpanel.track("Proceed_new_remitter");
                        setSkipClicked(false);
                      }
                    }
                  }}
                >
                  {otpSentCheck || skipClicked ? "SEND KYC LINK" : "SKIP"}
                </Button>
              </div>

              {/* <div className="w-full sm:w-[372px] flex items-center justify-between">
              {!isSendLink && (
                <div className={clsx(isOtpSend && !isSendLink ? "w-2/3" : "w-full")}>
                  <Controller
                    control={control}
                    name="otp"
                    rules={{ required: true, maxLength: 6, minLength: 6 }}
                    render={({ field: { name, onChange } }) => {
                      return (
                        <TextField
                          name={name}
                          type="number"
                          placeholder="Verfication Code"
                          inputClasses="border-[#EEEFF2]"
                          placeholderStyle="text-[#006EFF] font-ssp font-normal text-base"
                          value={formData?.otpValue}
                          onChange={(v) => {
                            addRemitterOnChangeHandler(v.target.value, "otpValue");
                            onChange(v);
                          }}
                          errorMessage={
                            otpError ||
                            getErrorMessage(errors as Record<string, { type: any }>, "otp", "OTP")
                          }
                          error={otpError !== "" || errors.otp}
                          required
                          fullWidth
                          disabled={isOtpDisabled}
                        />
                      );
                    }}
                  />
                </div>
              )}
            */}
              {isOtpSend && (
                <div>
                  <Countdown
                    key={dateKey}
                    date={date}
                    renderer={({ minutes, seconds, completed }) => {
                      if (completed) {
                        return (
                          <div
                            className="text-xs font-bold text-black cursor-pointer font-ssp"
                            onClick={() =>
                              handleMobileVerification("resend", "mobile")
                            }
                          >
                            Resend
                          </div>
                        );
                      } else {
                        return (
                          <div className="flex items-center space-x-2">
                            <div className="text-xs font-bold text-black font-ssp">
                              Resend
                            </div>
                            <div
                              className={
                                "text-xs font-bold text-primary font-ssp"
                              }
                            >
                              {zeroPad(minutes)} :{zeroPad(seconds)}
                            </div>
                          </div>
                        );
                      }
                    }}
                  />
                </div>
              )}
              {/* </div>  */}
              {signUpError?.email !== '' || signUpError?.mobile !== '' ? (
                <ErrorField
                  errorMessage={signUpError?.email || signUpError?.mobile}
                />
              ) : null}
              {/* <div className="">
              <Button
                bgColor="bg-secondary-600"
                fontStyle={{
                  fontFamily: "font-ssp",
                  fontSize: "text-base",
                  fontWeight: "font-semibold",
                  fontColor: "text-white",
                }}
                borderStyle={{
                  borderRadius: "rounded",
                }}
                className="w-56 sm:h-[54px]"
                disabled={otpLoading}
                onClickHandler={() => Mixpanel.track("Proceed_new_remitter ")}
              >
                {otpLoading ? (
                  <div className="mx-10 loader ease-linear rounded-full border-2 border-t-2 border-t-gray-300 border-white h-5 w-5"></div>
                ) : (
                  "Proceed"
                )}
              </Button>
            </div> */}
            </form>
          </div >
        </Modal >

        {/* Mobile Verification Options Modal */}
        {/* <Modal
          visible={isModalOpen === "mobileVerificationOptions"}
          header="Select Any Option"
          closeHandler={() => setIsModalOpen("")}
        >
          <div>
            <div className="flex items-center justify-center gap-10 p-8 pb-0">
              <Button
                bgColor="bg-secondary-600"
                fontStyle={{
                  fontFamily: "font-ssp",
                  fontSize: "text-base",
                  fontWeight: "font-semibold",
                  fontColor: "text-white",
                }}
                borderStyle={{
                  borderRadius: "rounded",
                }}
                className="p-2"
                isLoading={otpLoading}
                onClickHandler={() => {
                  // handleMobileVerification("send", "link"), setIsModalOpen(""), setIsSendLink(true)
                  handleLinkVerification("send", "link"),
                    setIsModalOpen(""),
                    setIsSendLink(true);
                }}
              >
                SEND LINK
              </Button>
              <Button
                bgColor="bg-secondary-600"
                fontStyle={{
                  fontFamily: "font-ssp",
                  fontSize: "text-base",
                  fontWeight: "font-semibold",
                  fontColor: "text-white",
                }}
                borderStyle={{
                  borderRadius: "rounded",
                }}
                className="p-2"
                onClickHandler={() => {
                  handleMobileVerification("send", "mobile");
                  Mixpanel.track("Send_Otp_new_remitter");
                  setIsModalOpen("");
                }}
                isLoading={otpLoading}
              >
                SEND CODE
              </Button>
            </div>
            <div className="flex justify-center items-center py-2 pb-0">
              <Button
                bgColor="bg-secondary-600"
                fontStyle={{
                  fontFamily: "font-ssp",
                  fontSize: "text-base",
                  fontWeight: "font-semibold",
                  fontColor: "text-white",
                }}
                borderStyle={{
                  borderRadius: "rounded",
                }}
                className="p-2"
                onClickHandler={() => {
                  handleLinkVerification("skip", "mobile");
                  setIsModalOpen("");
                  Mixpanel.track("Skip_send_otp_remitter");
                }}
              >
                Skip
              </Button>
            </div>
          </div>
        </Modal> */}

        {/* Remmiter selection Confirmation modal */}
        <Modal
          visible={isModalOpen === "confirmSelectedRemitter"}
          closeHandler={() => setIsModalOpen("")}
          closable={false}
        >
          <Typograpy
            tagType="div"
            className="text-base font-semibold text-center text-black"
          >
            {panMismatchError ? (
              <span className="text-[12px] text-red-100">
                Please upload the valid PAN card with the number{" "}
                {panDeclarationValue} or unselect the PAN number entered on the
                send money screen.{" "}
              </span>
            ) : (
              <span>
                Are you sure you want to select {selectedRemitter?.firstName}{" "}
                <br></br> as your remitter?
              </span>
            )}
          </Typograpy>
          <div className="flex items-center justify-center gap-10 p-8 pb-0">
            <Button
              bgColor="bg-secondary-600"
              fontStyle={{
                fontFamily: "font-ssp",
                fontSize: "text-base",
                fontWeight: "font-semibold",
                fontColor: "text-white",
              }}
              borderStyle={{
                borderRadius: "rounded",
              }}
              className="p-2 confirmButtonRemitter"
              onClickHandler={handleTransactionUpdate}
            >
              {panMismatchError ? "Cancel" : "Confirm"}
            </Button>
          </div>
        </Modal>

        {/* Remitter Delete Confirm Modal */}
        <Modal
          visible={isModalOpen === "confirmDeleteRemitter"}
          closeHandler={() => setIsModalOpen("")}
          closable={false}
        >
          <Typograpy
            tagType="div"
            className="text-base font-semibold text-center text-black"
          >
            Are you sure you want to remove {selectedRemitter?.firstName} from
            Remitter list?
          </Typograpy>
          <div className="flex items-center justify-center gap-10 p-8 pb-0">
            <Button
              bgColor="bg-secondary-600"
              fontStyle={{
                fontFamily: "font-ssp",
                fontSize: "text-base",
                fontWeight: "font-semibold",
                fontColor: "text-white",
              }}
              borderStyle={{
                borderRadius: "rounded",
              }}
              className="p-2"
              onClickHandler={() => setIsModalOpen("")}
            >
              Cancel
            </Button>
            <Button
              bgColor="bg-error"
              fontStyle={{
                fontFamily: "font-ssp",
                fontSize: "text-base",
                fontWeight: "font-semibold",
                fontColor: "text-white",
              }}
              borderStyle={{
                borderRadius: "rounded",
              }}
              className="p-2"
              onClickHandler={handleConfirmedRemitterDelete}
            >
              Delete
            </Button>
          </div>
        </Modal>
      </>
    );
  };

export default AddNewRemitterModal;
